import React from 'react'
import { AppSvg, Loader } from '@web/walter-ui-kit'

import cn from 'classnames'
import styles from './style.module.css'
import { images } from '~constants/images'

interface Props {
    withAnimation?: boolean
    hideTicks?: boolean
}

function ChartPreloader({ withAnimation = true, hideTicks }: Props) {
    return (
        <div className={styles.wrap}>
            <div className={cn(styles.chart, withAnimation && styles.animation)}>
                <AppSvg
                    size={{ width: '100%', height: '100%' }}
                    path="common"
                    themed={false}
                    svgName={images.chartNoData}
                />
            </div>

            <div className={cn(styles.ticks, hideTicks && styles.hidden)}>
                <Loader />
                <Loader />
                <Loader />
                <Loader />
            </div>
        </div>
    )
}

export default ChartPreloader
